var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2F2F2F",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.972,8.769c-.028-.117-.082-.224-.148-.323-.007-.011-.008-.023-.015-.034-.005-.007-.013-.01-.018-.017-.058-.076-.123-.146-.202-.204L12.587,.191c-.352-.256-.826-.256-1.177,0L.412,8.191c-.079,.058-.145,.128-.203,.204-.005,.007-.013,.009-.018,.016-.007,.01-.008,.022-.015,.033-.067,.1-.121,.207-.149,.325-.001,.006,0,.011-.002,.017-.015,.07-.025,.141-.025,.214v12c0,1.654,1.346,3,3,3H21c1.654,0,3-1.346,3-3V9c0-.073-.01-.143-.025-.213-.001-.006,0-.012-.002-.018ZM11.999,2.236l9.301,6.764-9.299,6.764L2.7,9,11.999,2.236Z",
    fill: "#2F2F2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email-open.f31e3d64ab7d6b2e1603ed1e996fcaf7.svg";
export { ForwardRef as ReactComponent };